import { CategoriesView } from "../views/CategoriesView";
import { DomainLayout } from "@/components/layouts/DomainLayout";

export const CategoriesPage = () => {
    return (
        <DomainLayout>
            <CategoriesView />
        </DomainLayout>
    )
};

